export default __webpack_public_path__ + "content/a16d8201b06a03c6c365341748a5cba0.ttf";